import { DEFAULT_REG_ITEM_IMAGE_PATH } from 'shared/constants'
import {
  REG_ITEM_TYPE_CROWDFUND,
  REG_ITEM_TYPE_EXTERNAL_REGISTRY,
  REG_ITEM_TYPE_GIFT_CARD,
  REG_ITEM_TYPE_GROUP_GIFT,
} from 'src/constants'
import { RegItemMinimal } from 'src/types/regItem'
import getRegItemType from '../../../../utils/getRegItemType/getRegItemType'
import { ReservationWithVisitor } from '../../../RegistryCategories/RegistryCategories.types'

export const NO_QUANTITY_REG_ITEM_TYPES = [
  REG_ITEM_TYPE_CROWDFUND,
  REG_ITEM_TYPE_EXTERNAL_REGISTRY,
  REG_ITEM_TYPE_GROUP_GIFT,
  REG_ITEM_TYPE_GIFT_CARD,
]

const isQuantityUnlimited = (regItem: RegItemMinimal): boolean =>
  regItem.quantity === null || regItem.quantity < 0

export const shouldDisplayQuantity = (
  regItem: RegItemMinimal,
  reservation?: ReservationWithVisitor
): boolean => {
  const regItemType = getRegItemType(regItem)
  if (NO_QUANTITY_REG_ITEM_TYPES.includes(regItemType || '')) {
    return false
  }

  if (reservation && reservation.quantity > 1) {
    return true
  }

  const isUnlimited = isQuantityUnlimited(regItem)

  return regItem.quantityNeeded > 1 || isUnlimited
}

export const getQuantityText = (
  regItem: RegItemMinimal,
  reservation?: ReservationWithVisitor
): string | number => {
  if (reservation) {
    return `Qty: ${reservation.quantity}`
  }

  const isUnlimited = isQuantityUnlimited(regItem)
  const count = isUnlimited ? 'Unlimited' : regItem.quantityNeeded
  return `Wants: ${count}`
}

export const shouldDisplayMissingImage = (regItem: RegItemMinimal): boolean =>
  !regItem.imgUrl || regItem.imgUrl === DEFAULT_REG_ITEM_IMAGE_PATH
